/**
 * Created by mestrad on 2018. 06. 28..
 */

var PageParameters = {
    parameterStore: [],

    getParam: function (name) {
        if (name in this.parameterStore) {
            return this.parameterStore(name);
        }

        return undefined;
    },
    setParam: function (name, value) {
        this.parameterStore[name] = value;
    },
};

export default PageParameters;
